import {components, SingleValueProps} from "react-select";

import {SelectOption} from "@/components/select/Select.types.ts";

import styles from "./InlineLabelSingleValue.module.scss";

/**
 * Shows the select's `aria-label` ahead of its value ("Interval Auto"), so a compact
 * control needs no label above it and its accessible name matches what is on screen.
 */
export const InlineLabelSingleValue = ({children, ...props}: SingleValueProps<SelectOption, false>) => (
  <components.SingleValue {...props}>
    <span className={styles.label}>{props.selectProps["aria-label"]}</span> {children}
  </components.SingleValue>
);
